import { useHead } from '@unhead/vue'

const BRAND = 'Hai Afară!'

/**
 * Sets the page <title> reactively, appending the brand name.
 *
 * @param {() => string} titleFn - Reactive getter returning the page-specific title string.
 *   Return an empty/falsy value to show just the brand name.
 * @param {Object} [options]
 * @param {boolean} [options.brandFirst=false] - When true, renders "Hai Afară! - {title}"
 *   instead of "{title} - Hai Afară!". Use for the home page.
 */
export function usePageTitle(titleFn, options = {}) {
  useHead({
    title: () => {
      const title = titleFn()
      if (!title) return BRAND
      return options.brandFirst ? `${BRAND} - ${title}` : `${title} - ${BRAND}`
    },
  })
}
